import React from 'react';
import { Typography } from 'src/components/PulseUI';

const StreetAddressCell = ({ row }) => {
  const addressData = row.provider?.primary_address || row?.primary_address;
  const { address_line_1, address_line_2 } = addressData ?? {};
  if (!address_line_1 && !address_line_2) return null;
  return (
    <Typography variant="body2">
      {[address_line_1, address_line_2].filter(Boolean).join(' ')}
    </Typography>
  );
};

export default StreetAddressCell;
